// utils/logClientError.js

export function logClientError(error, context = 'unknown', options = {}) {
    try {
      const normalizedError = typeof error === 'string' ? new Error(error) : error;

      // Optional PostHog session id (posthog-js get_session_id()) — the join key
      // from this durable Client Errors row back to the PostHog session. Only sent
      // when the caller supplies it; omitted (server writes null) otherwise.
      const { sessionID } = options;

      fetch('/api/log-client-error', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message: normalizedError.message || 'Unknown client error',
          stack: normalizedError.stack || null,
          context,
          url: window.location.href,
          userAgent: navigator.userAgent,
          ...(sessionID ? { posthogSessionID: sessionID } : {}),
        }),
      });
    } catch (loggingError) {
      console.warn('Failed to log client error:', loggingError);
    }
  }
  